import { render, staticRenderFns } from "./InformTabel.vue?vue&type=template&id=9802f2e4&scoped=true"
import script from "./InformTabel.vue?vue&type=script&lang=js"
export * from "./InformTabel.vue?vue&type=script&lang=js"
import style0 from "./InformTabel.vue?vue&type=style&index=0&id=9802f2e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9802f2e4",
  null
  
)

export default component.exports